import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { computePortfolioBook } from './domain/computePortfolioBook'

const includeFutures = ref(false)

export function usePortfolioToolbar() {
  const store = useStore()

  const book = computed(() =>
    computePortfolioBook({
      ledger: store.state.ledger,
      shortLedger: store.state.shortLedger,
      futuresInfos: store.state.futuresInfos,
      includeFutures: includeFutures.value,
      markPrice: store.state.marketData?.btcUsd || store.state.marketData?.price || 0,
    })
  )

  function toggleFutures() {
    includeFutures.value = !includeFutures.value
  }

  return {
    book,
    includeFutures,
    toggleFutures,
    pmp: computed(() => book.value.pmp),
    hedgeAvg: computed(() => book.value.hedgeAvg),
    manualQty: computed(() => book.value.manualQty),
    shortQty: computed(() => book.value.shortQty),
    coverage: computed(() => book.value.coverage),
    coverageTone: computed(() => book.value.coverageTone),
    headRoom: computed(() => book.value.headRoom),
    netPnl: computed(() => book.value.netPnl),
  }
}
